<template>
  <!-- <div className="fs-2 fw-semibold">{{ currentBreadcrumb }}</div> -->
  <CBreadcrumb class="mb-0">
    <CBreadcrumbItem v-for="item in breadcrumbs" :key="item" :href="item.active ? '' : item.path" :active="item.active">
      {{ item.name }}
    </CBreadcrumbItem>
  </CBreadcrumb>
</template>

<script>
import { onMounted, ref } from 'vue'
import router from '@/router'

export default {
  name: 'AppBreadcrumb',
  setup() {
    const breadcrumbs = ref()
    const currentBreadcrumb = ref()
    const getBreadcrumbs = () => {
      let breadcrumbsRoute = []
      const dynamicIds = router.currentRoute.value.params.id
      if (dynamicIds) {
        const currentRouter = router.currentRoute.value.path.replaceAll(`/${dynamicIds}`, '')
        breadcrumbsRoute = router.getRoutes()?.filter(items => {
          if (items.path.includes(currentRouter) || items.path === '/') {
            return items
          }
        }).sort((a, b) => a.meta.order - b.meta.order)
      } else {
        breadcrumbsRoute = router.currentRoute.value?.matched
      }
      const routes = breadcrumbsRoute.map((route) => {
        const id = route.path.split(':')[1]
        const path = route.path.includes(id) ? route.path.replace(`:${id}`, dynamicIds) : route.path
        return {
          active: path === router.currentRoute.value.fullPath,
          name: route.name,
          path: `${router.options.history.base}${route.path}`,
        }
      })
      return routes
    }

    router.afterEach(() => {
      breadcrumbs.value = getBreadcrumbs()
    })
    onMounted(() => {
      breadcrumbs.value = getBreadcrumbs()
      currentBreadcrumb.value = [...breadcrumbs.value].pop().name
    })
    return {
      breadcrumbs,
      currentBreadcrumb,
    }
  },
}
</script>
